var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-QR",
    clipPath: "url(#clip0_343_41125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6005 41.2556H8.18861C4.07199 41.2556 0.744446 37.9206 0.744446 33.8114V28.3921",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.2556 28.3921V33.8114C41.2556 37.9206 37.9206 41.2556 33.8114 41.2556H28.3921",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.744446 13.6005V8.18855C0.744446 4.07937 4.07199 0.744385 8.18861 0.744385H13.6005",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.3921 0.744385H33.8114C37.9206 0.744385 41.2556 4.07937 41.2556 8.18855V13.6005",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.3251 6.9082H9.402C8.02471 6.9082 6.9082 8.02471 6.9082 9.402V16.3251C6.9082 17.7024 8.02471 18.8189 9.402 18.8189H16.3251C17.7024 18.8189 18.8189 17.7024 18.8189 16.3251V9.402C18.8189 8.02471 17.7024 6.9082 16.3251 6.9082Z",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.6774 10.0497H10.0496V15.6775H15.6774V10.0497Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.3251 23.1812H9.402C8.02471 23.1812 6.9082 24.2977 6.9082 25.675V32.598C6.9082 33.9753 8.02471 35.0918 9.402 35.0918H16.3251C17.7024 35.0918 18.8189 33.9753 18.8189 32.598V25.675C18.8189 24.2977 17.7024 23.1812 16.3251 23.1812Z",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.6774 26.3226H10.0496V31.9504H15.6774V26.3226Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M32.598 6.9082H25.675C24.2977 6.9082 23.1812 8.02471 23.1812 9.402V16.3251C23.1812 17.7024 24.2977 18.8189 25.675 18.8189H32.598C33.9753 18.8189 35.0918 17.7024 35.0918 16.3251V9.402C35.0918 8.02471 33.9753 6.9082 32.598 6.9082Z",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M31.9504 10.0497H26.3226V15.6775H31.9504V10.0497Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M27.1489 23.1812H23.1812V27.1489H27.1489V23.1812Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M35.0844 23.1812H31.1166V27.1489H35.0844V23.1812Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M31.1166 27.1489H27.1489V31.1167H31.1166V27.1489Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M27.1489 31.1166H23.1812V35.0843H27.1489V31.1166Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M35.0844 31.1166H31.1166V35.0843H35.0844V31.1166Z",
    fill: "#FEFAED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_41125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr_icon.b6e32f1b0dcdda74d0453bd8ead2dfc5.svg";
export { ForwardRef as ReactComponent };